import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { AddOn } from 'anchor-shared/lib/model/entity/addOn';

@Injectable()
export class AddOnDAO extends BaseDAO<AddOn> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.ADD_ON);
  }

  public createAddOn(vesselId, addOn: AddOn): Observable<AddOn> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/create';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      vesselId,
      addOn,
    };
    return this.apiHelper.apiCall<AddOn>(url, method, null, data, headers);
  }

  public getAddOnByVesselId(
    vesselId: number,
    type?: 'required' | 'optional',
  ): Observable<AddOn[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/get-by-vessel-id' +
      (type ? `/${type}` : '') +
      `/${vesselId}`;
    console.log('url', url);
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<AddOn[]>(url, method, null, null, headers);
  }

  public updateAddOn(vesselId, addOn: AddOn): Observable<AddOn> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/update';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      vesselId,
      addOn,
    };
    return this.apiHelper.apiCall<AddOn>(url, method, null, data, headers);
  }

  public deleteById(vesselId, addOnId: number): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + `/${addOnId}`;
    const method = 'DELETE';
    const data = { vesselId };
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(url, method, null, data, headers);
  }

  public notifyAdminOfAddOnAdjustment(
    charterId,
  ): Observable<{ success: boolean }> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/notify-admin/${charterId}`;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<{ success: boolean }>(
      url,
      method,
      null,
      null,
      headers,
    );
  }
}
